import { render, staticRenderFns } from "./forgetPassWord.vue?vue&type=template&id=39c569ea&scoped=true&"
import script from "./forgetPassWord.vue?vue&type=script&lang=js&"
export * from "./forgetPassWord.vue?vue&type=script&lang=js&"
import style0 from "./forgetPassWord.vue?vue&type=style&index=0&id=39c569ea&lang=less&scoped=true&"
import style1 from "./forgetPassWord.vue?vue&type=style&index=1&id=39c569ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c569ea",
  null
  
)

export default component.exports